import { render } from "./InventoryLog.vue?vue&type=template&id=6d2d4324"
import script from "./InventoryLog.vue?vue&type=script&lang=js"
export * from "./InventoryLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__